export class ProductForm extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))

    const addLabel = this.els['add-label']

    if (addLabel?.exists !== true) return

    this.listeners.add(this.form, 'change', this.onQuickshopVariantChange.bind(this))
    this.listeners.add(
      addLabel.element,
      'click',
      this.onQuickshopAddLabelActivate.bind(this),
    )
    this.listeners.add(
      addLabel.element,
      'keydown',
      this.onQuickshopAddLabelKeydown.bind(this),
    )
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    const requiresSizeSelection = this.form?.dataset.sizeSelectionRequired === 'true'
    const hasCompletedSizeSelection = this.form?.dataset.sizeSelectionComplete === 'true'

    if (requiresSizeSelection === true && hasCompletedSizeSelection === false) {
      if (window.jQuery) {
        window.jQuery(this.form).trigger('sizeSelectionRequired')
      }

      return
    }

    await this.addToCart()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  onQuickshopVariantChange (event) {
    const input = event.target

    if (
      input?.name !== 'id' ||
      input.disabled === true ||
      input.checked !== true
    ) {
      return
    }

    this.submitQuickshop()
  }

  onQuickshopAddLabelActivate (event) {
    event.preventDefault()
    this.submitQuickshop()
  }

  onQuickshopAddLabelKeydown (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return

    event.preventDefault()
    this.submitQuickshop()
  }

  submitQuickshop () {
    if (this.selectedVariantInput == null || this.form == null) return

    this.form.requestSubmit()
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }

  /**
   * @returns {HTMLInputElement|null}
   */
  get selectedVariantInput () {
    return this.form?.querySelector('input[name="id"]:checked:not(:disabled)')
  }
}

customElements.define('product-form', ProductForm)
